import request from "../request";

export default {
  // 列表
  lists(data) {
    return request.get("/Material/listMaterial", data);
  },
  
  //添加
  add(data) {
    return request.post("/Material/addMaterial", data);
  },
	
	//添加
	addSingleMaterial(data) {
		return request.post("/Material/addSingleMaterial", data);
	},
  
  // 编辑
  edit(data) {
    return request.post("/Material/editMaterial", data);
  },
  
  // 删除
  delete(data) {
    return request.post("/Material/deleteMaterial", data);
  },
  
  // 详情
  getSceneDetail(data) {
    return request.get("/Material/getSceneDetail", data);
  },
  
  editMaterial(data) {
    return request.post("/Material/editMaterial", data);
  },
	
	editMaterialInfo(data) {
		return request.post("/Material/editMaterialInfo", data);
	},
	
	addRetakeMaterial(data) {
		return request.post("/Material/addRetakeMaterial", data);
	},
	
	
	
};
